export default "__VITE_ASSET__C6CdO9Uk__"